let IS_PROD=true;
const servers=IS_PROD ? 
"https://videomeet-72l8.onrender.com" :
    "http://localhost:8000";
    
export default servers;